<mat-form-field>
   <mat-label>{{ label }}</mat-label>
   <mat-select [formControl]="formCtrl" [multiple]="multiple" [required]="required">
      <button mat-button color="primary" (click)="showEarlier()">Show Earlier</button>
      <mat-option value="Pending">Pending</mat-option>
      <mat-option *ngFor="let quarter of quarters" [value]="quarter">{{ quarter }}</mat-option>
      <button mat-button color="primary" (click)="showLater()">Show Later</button>
   </mat-select>
</mat-form-field>
